import { Flex, Spinner, VStack } from '@chakra-ui/react';
import { IconMap } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import React from 'react';
import { useVerifyEmailViewModel } from '../models/VerifyEmailViewModel';
import { PageHeader } from './components/PageHeader';
import { UI } from './components/UI';

type Content = {
  title: string;
  text: string;
  icon: keyof typeof IconMap;
  colorScheme: 'gray' | 'green' | 'red';
};

export const VerifyEmailPage: React.FC = () => {
  const viewModel = useVerifyEmailViewModel();
  const state = viewModel.viewState;

  let content: Content;
  switch (state) {
    case 'loading':
      content = {
        colorScheme: 'gray',
        icon: 'robot',
        text: 'Please wait while we verify your email address.',
        title: 'Verifying your email address',
      };
      break;
    case 'success':
      content = {
        colorScheme: 'green',
        icon: 'circle-check',
        text: 'You can now close this window.',
        title: 'Your email address has been verified',
      };
      break;
    case 'error':
      content = {
        colorScheme: 'red',
        icon: 'times',
        text: 'Please try again later.',
        title: 'There was an error verifying your email address',
      };
      break;
  }

  return (
    <UI>
      <Flex px={[6, 20]} pt={['24px', '56px']} pb={[20, 200]} direction={'column'} gap={10} align="center">
        <PageHeader
          title={content.title}
          subtitle={content.text}
          icon={content.icon}
          iconColorScheme={content.colorScheme}
        />
        <VStack gap={10}>
          <Image image="logo-white" w={200} />
          {state === 'loading' && <Spinner size="xl" borderWidth={5} />}
        </VStack>
      </Flex>
    </UI>
  );
};
